<template>
  <div class="title">
    <span>{{ titleText }}</span>
  </div>
</template>

<script>
export default {
  name: "greentitle",
  props: ['titleText']
};
</script>

<style scoped lang='less'>
.title {
  font-size: 0.24rem * 2;
  color: #222328;
  font-weight: bold;
  padding-left: 0.24rem;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    width: 0.08rem;
    height: 0.48rem;
    background: #9D6C29;
    border-radius: 0.053334rem;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
